/* ==========================================================================
   Handelsteil: Warenkorb, Variantenwahl, Sortierung, Bildwechsel.
   Der Warenkorb liegt bei Shopify; hier laufen nur die Aufrufe der
   /cart-Schnittstelle und das Nachzeichnen der Schublade.
   ========================================================================== */
(function(){
  'use strict';
  var W = window, doc = document;
  function $(s, k){ return (k||doc).querySelector(s); }
  function $$(s, k){ return Array.prototype.slice.call((k||doc).querySelectorAll(s)); }

  var KORB = $('#korb'), LISTE = $('#korb-liste'), FUSS = $('#korb-fuss');

  /* ---------------------------------------------------------------- Meldung */
  var tTimer;
  function melden(text){
    var t = $('#toast'), s = $('#toast-txt');
    if(!t || !s) return;
    s.textContent = text;
    t.classList.add('an');
    clearTimeout(tTimer);
    tTimer = setTimeout(function(){ t.classList.remove('an'); }, 2600);
  }

  /* ------------------------------------------------------------- Schublade */
  function aufziehen(){
    if(!KORB) return;
    if(!KORB.classList.contains('an')) KORB._von = doc.activeElement;
    KORB.classList.add('an');
    doc.documentElement.classList.add('lock-korb');
    /* Tastatur: Fokus in die Schublade, beim Schliessen zurueck (WCAG 2.4.3) */
    var f = $('.korb-c button,.korb-c a', KORB);
    if(f) setTimeout(function(){ f.focus(); }, 60);
  }
  function zuziehen(){
    if(!KORB) return;
    KORB.classList.remove('an');
    doc.documentElement.classList.remove('lock-korb');
    if(KORB._von && KORB._von.focus){ KORB._von.focus(); KORB._von = null; }
  }
  if(KORB){
    KORB.addEventListener('click', function(e){
      if(e.target.closest('[data-zu]')) zuziehen();
    });
    doc.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && KORB.classList.contains('an')) zuziehen();
    });
  }
  doc.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-korb-auf]');
    if(!b) return;
    e.preventDefault();
    aufziehen();
  });

  /* -------------------------------------------------- Stand neu einlesen */
  /* Der Abschnitt 'korb' wird von der Cart-Schnittstelle gleich mitgeliefert
     (Feld "sections" im Aufruf) — ein Weg statt zwei, und die Preise sind
     genau so formatiert wie im übrigen Shop. */
  var MIT_ABSCHNITT = { sections: 'korb', sections_url: W.location.pathname };

  function zeichnen(antwort){
    if(typeof antwort.item_count === 'number'){
      W.KORB_ANZAHL = antwort.item_count;
      if(W.HUETTE && W.HUETTE.badge) W.HUETTE.badge();
      if(FUSS) FUSS.hidden = antwort.item_count === 0;
    }
    var roh = antwort.sections && antwort.sections['korb'];
    if(!roh) return;
    var hilf = doc.createElement('div');
    hilf.innerHTML = roh;
    var neueListe = $('#korb-liste', hilf), neuerFuss = $('#korb-fuss', hilf);
    if(neueListe && LISTE) LISTE.innerHTML = neueListe.innerHTML;
    if(neuerFuss && FUSS){ FUSS.innerHTML = neuerFuss.innerHTML; FUSS.hidden = neuerFuss.hasAttribute('hidden'); }
  }

  function stand(){
    return fetch(W.Shopify.routes.root + 'cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); });
  }

  /* ------------------------------------------------------------- Hinzufügen */
  $$('[data-korb-form]').forEach(function(f){
    f.addEventListener('submit', function(e){
      e.preventDefault();
      var knopf = $('[type=submit]', f);
      if(knopf) knopf.classList.add('laedt');
      /* Posteneigenschaften (Gutschein-Empfaenger) mitschicken. :disabled
         statt .disabled — Felder in einem gesperrten fieldset tragen das
         Attribut nicht selbst. */
      var posten = { id: Number(f.querySelector('[name=id]').value),
                     quantity: Number((f.querySelector('[name=quantity]')||{}).value || 1) };
      $$('[name^="properties["]', f).forEach(function(el){
        if(el.matches(':disabled') || el.value === '') return;
        if(el.type === 'checkbox' && !el.checked) return;
        (posten.properties = posten.properties || {})[el.name.slice(11, -1)] = el.value;
      });
      fetch(W.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json', 'Accept':'application/json'},
        body: JSON.stringify({
          items: [posten],
          sections: MIT_ABSCHNITT.sections,
          sections_url: MIT_ABSCHNITT.sections_url
        })
      })
      .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
      .then(function(a){
        if(!a.ok){ melden(a.d.description || 'Das hat leider nicht geklappt.'); return; }
        /* cart/add.js meldet nur die neuen Posten zurück, nicht den Gesamtstand —
           die Anzahl kommt deshalb aus cart.js hinterher. */
        zeichnen(a.d);
        melden('In den Warenkorb gelegt');
        aufziehen();
        return stand().then(function(k){
          W.KORB_ANZAHL = k.item_count;
          if(W.HUETTE && W.HUETTE.badge) W.HUETTE.badge();
          if(FUSS) FUSS.hidden = k.item_count === 0;
        });
      })
      .catch(function(){ melden('Keine Verbindung — bitte noch einmal versuchen.'); })
      .then(function(){ if(knopf) knopf.classList.remove('laedt'); });
    });
  });

  /* ------------------------------------------------------- Menge und Löschen */
  function aendern(schluessel, menge){
    return fetch(W.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Accept':'application/json'},
      body: JSON.stringify({ id: schluessel, quantity: menge,
                             sections: MIT_ABSCHNITT.sections,
                             sections_url: MIT_ABSCHNITT.sections_url })
    })
    .then(function(r){ return r.json(); })
    .then(zeichnen)
    .catch(function(){ melden('Keine Verbindung — bitte noch einmal versuchen.'); });
  }

  if(LISTE){
    LISTE.addEventListener('click', function(e){
      var b = e.target.closest('button'); if(!b) return;
      var posten = b.closest('.pos'); if(!posten) return;
      var schluessel = posten.getAttribute('data-schluessel');
      var jetzt = Number(($('.pos-menge b', posten)||{}).textContent || 1);
      if(b.hasAttribute('data-plus'))       aendern(schluessel, jetzt + 1);
      else if(b.hasAttribute('data-minus')) aendern(schluessel, Math.max(0, jetzt - 1));
      else if(b.hasAttribute('data-weg'))   aendern(schluessel, 0);
    });
  }

  /* --------------------------------------------------- Produktseite: Menge */
  $$('[data-menge]').forEach(function(b){
    b.addEventListener('click', function(){
      var feld = $('[data-menge-feld]', b.closest('.pos-menge'));
      if(!feld) return;
      feld.value = Math.max(1, Number(feld.value || 1) + Number(b.getAttribute('data-menge')));
    });
  });

  /* ---------------------------------------------- Produktseite: Varianten */
  var pForm = $('.pd-form');
  if(pForm && W.PRODUKT_VARIANTEN){
    var waehler = $$('[data-opt]', pForm);
    waehler.forEach(function(s){
      s.addEventListener('change', function(){
        var gewaehlt = waehler.map(function(x){ return x.value; });
        var treffer = W.PRODUKT_VARIANTEN.filter(function(v){
          return v.options.every(function(o, i){ return o === gewaehlt[i]; });
        })[0];
        var feld = $('[data-variante]', pForm), knopf = $('[data-kaufen]', pForm);
        if(!treffer){
          if(knopf){ knopf.disabled = true; $('span', knopf).textContent = 'Nicht verfügbar'; }
          return;
        }
        if(feld) feld.value = treffer.id;
        if(knopf){
          knopf.disabled = !treffer.available;
          $('span', knopf).textContent = treffer.available ? 'In den Warenkorb' : 'Zurzeit vergriffen';
        }
        /* Die Lieferzeit ist eine Pflichtangabe und haengt an der Variante —
           sie muss beim Umschalten der Groesse mitwandern. */
        var lz = $('#pd-liefer');
        if(lz){
          lz.innerHTML = treffer.available
            ? '<span class="pd-punkt pd-da" aria-hidden="true"></span>Lieferzeit ' + (W.HUETTE_LIEFERZEIT || '')
            : '<span class="pd-punkt pd-weg" aria-hidden="true"></span>Zurzeit vergriffen \u2013 wir sagen euch am Telefon, wann es wieder da ist';
        }
        var preis = $('.pd-jetzt');
        if(preis && treffer.preis_text) preis.textContent = treffer.preis_text;
        /* Der Streichpreis gehoert zur Variante: die 8,5-l-Tasche hat eine
           andere UVP als die 7-l-Tasche. */
        /* Grundpreis je Variante (Seile 60/80 m: anderer Preis je Meter). */
        var gp = $('.pd-grund');
        if(gp){
          if(treffer.grund_text){ gp.textContent = treffer.grund_text; gp.hidden = false; }
          else { gp.hidden = true; }
        }
        var uvp = $('#pd-uvp');
        if(uvp){
          if(treffer.uvp_text){ $('s', uvp).textContent = treffer.uvp_text; uvp.hidden = false; }
          else { uvp.hidden = true; }
        }
        /* Die Kaufleiste zeigt denselben Stand — sonst steht unten der Preis
           der zuerst gewaehlten Groesse. */
        var klp = $('#kl-preis'), klk = $('#kl-knopf');
        if(klp && treffer.preis_text) klp.textContent = treffer.preis_text;
        if(klk){
          klk.disabled = !treffer.available;
          $('span', klk).textContent = treffer.available ? 'In den Warenkorb' : 'Vergriffen';
        }
        /* Bild der Variante nach vorn holen */
        if(treffer.bild){ var gross = $('#pd-bild'); if(gross){ gross.src = treffer.bild; gross.removeAttribute('srcset'); } }
        var url = new URL(W.location.href);
        url.searchParams.set('variant', treffer.id);
        W.history.replaceState({}, '', url);
      });
    });
  }

  /* ------------------------------------------ Produktseite: Kaufleiste
     Auf dem Handy blendet sie sich ein, sobald der echte Kaufknopf aus dem
     Bild gescrollt ist — und wieder aus, sobald er zurueckkommt. Ohne diesen
     zweiten Weg zum Korb ist der teuerste Klick auf dem Handy das
     Zurueckscrollen. */
  var LEISTE = $('#kaufleiste'), KKNOPF = $('#kl-knopf');
  if(LEISTE && pForm){
    doc.body.classList.add('hat-kaufleiste');
    var echterKnopf = $('[data-kaufen]', pForm);
    if(KKNOPF && echterKnopf){
      KKNOPF.addEventListener('click', function(){ echterKnopf.click(); });
    }
    if('IntersectionObserver' in W && echterKnopf){
      new IntersectionObserver(function(e){
        LEISTE.classList.toggle('an', !e[0].isIntersecting);
        LEISTE.setAttribute('aria-hidden', e[0].isIntersecting ? 'true' : 'false');
      }, {threshold:0}).observe(echterKnopf);
    } else {
      LEISTE.classList.add('an');
    }
  }

  /* --------------------------------------- Produktseite: Beschreibung
     Am Rechner steht die Beschreibung offen da. Auf dem Handy waere sie das
     erste, was den Kaufknopf aus dem Bild schiebt — dort startet sie
     zugeklappt. Eine <details> laesst sich per CSS nicht schliessen, deshalb
     hier und nicht im Stylesheet. */
  var beschr = $('#pd-a-text');
  if(beschr && W.matchMedia && W.matchMedia('(max-width:699px)').matches){
    beschr.open = false;
  }

  /* ------------------------------------------------ Produktseite: Bildwahl */
  $$('.pd-mini-b').forEach(function(b){
    b.addEventListener('click', function(){
      var gross = $('#pd-bild'); if(!gross) return;
      gross.src = b.getAttribute('data-gross');
      gross.removeAttribute('srcset');
      $$('.pd-mini-b').forEach(function(x){ x.classList.remove('sel'); });
      b.classList.add('sel');
    });
  });

  /* ------------------------------------------------------------ Sortierung */
  var sortier = $('[data-sortierung]');
  if(sortier){
    sortier.addEventListener('change', function(){
      var url = new URL(W.location.href);
      url.searchParams.set('sort_by', sortier.value);
      url.searchParams.delete('page');
      W.location.href = url.toString();
    });
  }

  /* Beim Laden einmal den echten Stand übernehmen */
  if(W.Shopify && W.Shopify.routes){
    stand().then(function(k){
      W.KORB_ANZAHL = k.item_count;
      if(W.HUETTE && W.HUETTE.badge) W.HUETTE.badge();
      if(FUSS) FUSS.hidden = k.item_count === 0;
    }).catch(function(){});
  }
})();
